import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcLocation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.75 10a6.75 6.75 0 1 0-12.937 2.7c.624 1.427 1.651 2.83 2.823 4.23.583.697 1.193 1.382 1.798 2.065a76 76 0 0 1 1.564 1.809c.501-.61 1.03-1.22 1.559-1.827.596-.685 1.192-1.366 1.766-2.059 1.148-1.385 2.174-2.78 2.87-4.234A6.7 6.7 0 0 0 18.75 10m-5-.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m6.5.5c0 1.173-.247 2.29-.689 3.3l-.01.023c-.777 1.626-1.898 3.134-3.072 4.552-.589.71-1.2 1.408-1.791 2.087a74 74 0 0 0-1.706 2.007 1.267 1.267 0 0 1-1.963.003A66 66 0 0 0 9.31 19.99c-.6-.678-1.226-1.38-1.826-2.097-1.195-1.43-2.335-2.964-3.047-4.592A8.25 8.25 0 1 1 20.25 10m-5-.5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0"
  }));
}
var IcLocation = createNolIcon(/*#__PURE__*/forwardRef(SvgIcLocation));

export { IcLocation as I };
